module.exports = __webpack_public_path__ + "img/img70.4f00255e.png";